if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      // TLR TASK-762: enquiry templates (no buyable ATC) reveal the panel uniformly
      // early -- after the visitor scrolls ~one screen -- on every enquiry template
      // regardless of layout. A form-based trigger was inconsistent: some templates
      // have no product-form, or one outside .cc-main-product, so it revealed late there.
      this.enquiryEarly = this.hasAttribute('data-enquiry-early');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      if (this.revealOnScroll) window.removeEventListener('scroll', this.revealOnScroll);
    }

    bindEvents() {
      if (this.enquiryEarly) {
        // Reveal once the visitor has scrolled ~one full screen -- a uniform, early,
        // layout-independent depth so the Enquire appears at the same point on every
        // enquiry template. Reading scrollY on each scroll is reliable at any speed.
        this.revealOnScroll = () => {
          this.classList.toggle('sticky-atc-panel--out', window.scrollY < window.innerHeight);
        };
        window.addEventListener('scroll', this.revealOnScroll, { passive: true });
        this.revealOnScroll();
      } else {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.productForm && !theme.mediaMatches.md) {
              this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
            } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
              this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
            }
          });
        });

        if (this.productForm) observer.observe(this.productForm);
        if (this.productInfo) observer.observe(this.productInfo);
      }

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
